import React from 'react';
import { DialogTitle } from '@headlessui/react';
import { useTranslation } from 'react-i18next';
import { useWidgetsModalContext } from '../../../../shared/providers/WidgetsModalProvider';

import Button from '../../../widgets/Button';
import Modal from '../../../widgets/Modal';

import { handleGeneratedHide } from '../toast';
import reportStatus from '../../../../assets/icons/report-status.png';

interface IReportModals {
  open: boolean;
  setGeneratedSuccessfully: (value: boolean) => void;
}

function ReportGenerated({ open, setGeneratedSuccessfully }: IReportModals) {
  const { setShowDownloadReport } = useWidgetsModalContext();
  const { t } = useTranslation();
  return (
    <Modal
      open={open}
      handleClose={() => {
        setShowDownloadReport(false);
        setGeneratedSuccessfully(false);
        handleGeneratedHide();
      }}
      modalClassName="w-[400px]"
      closeButton
    >
      <div className="grid justify-normal pt-[22px] text-center">
        <img src={reportStatus} className="m-auto mb-[34px] w-[142px]" alt="" />
        <DialogTitle
          as="h4"
          className="text-black-900 mb-2 text-lg font-semibold"
        >
          {t('REPORT_SUCCESS_HEADING')}
        </DialogTitle>
        <p className="text-black-600 mb-8 text-sm">
          {t('REPORT_SUCCESS_SUBHEADING')}
        </p>

        <Button
          size="lg"
          onClick={() => {
            setShowDownloadReport(false);
            setGeneratedSuccessfully(false);
            handleGeneratedHide();
          }}
        >
          {t('FEEDBACK_SUCCESS_BUTTON')}
        </Button>
      </div>
    </Modal>
  );
}

export default ReportGenerated;
